import React from 'react';

import { replaceAll } from '../../components/Base/mol_function';

export default class MediaMidvox extends React.Component {
  mediaRef;
  midvoxContainerRef;
  handle: any;

  constructor(props) {
    super(props);
    this.handle = null;
    this.mediaRef = React.createRef();
    this.midvoxContainerRef = React.createRef();
  }
  componentDidMount() {
    let ean = this.props.ean;
    try {
      this.handle = new MX_BookPreview('7093121140', ean, '5', 3);
    } catch {}
    if (this.handle != null) {
      this.handle.setCntId('3149896205');

      this.handle.setIncludeDiv('midvox_container');
      this.handle.show();
    }
    let midvoxContainer = this.midvoxContainerRef.current;
    setTimeout(() => {
      let tmp = midvoxContainer;
      let internFrame = tmp.children[0];
      if (internFrame != undefined) {
        internFrame.style.width = '100%';
        internFrame.style.minHeight = '500px';
      }
    }, 2000);
  }

  render() {
    return (
      <div ref={this.mediaRef}>
        <script
          type="text/javascript"
          src="//www.blickinsbuch.de/gateway/widget.js"
        ></script>
        <div id="midvox_container" ref={this.midvoxContainerRef}></div>
      </div>
    );
  }
}
